"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessoriesIncVatPrice = void 0;
const next_1 = require("../../../next");
const getAccessoriesIncVatPrice = (order, vehicleConfiguration) => {
    var _a;
    if (!(0, next_1.isElectricVehicle)(vehicleConfiguration))
        return 0;
    const accessories = (order === null || order === void 0 ? void 0 : order.accessories) || [];
    const customerType = (_a = order === null || order === void 0 ? void 0 : order.customer) === null || _a === void 0 ? void 0 : _a.customerType;
    const accessoriesIncVat = Array.isArray(accessories) ? accessories.filter((accessory) => (accessory === null || accessory === void 0 ? void 0 : accessory.vat) > 0) : [];
    return accessoriesIncVat.reduce((total, accessory) => total + (0, next_1.getAccessoryCalculatedPriceByCustomerType)(accessory, customerType), 0);
};
exports.getAccessoriesIncVatPrice = getAccessoriesIncVatPrice;
//# sourceMappingURL=accessory-price.js.map